export default {
    title: '核稿审查',
    noSessions: '暂无审查记录',
    noSessionsHint: '运行核稿工具后，结果将显示在此处',
    rules: '条规则',
    loadFailed: '加载失败，请重试',
    view: {
        issues: '问题列表',
        patent: '专利原文',
    },
    filter: {
        all: '全部',
        critical: '严重',
        error: '错误',
        warning: '警告',
        pass: '通过',
    },
    issue: {
        ignore: '忽略',
        ignored: '已忽略',
        applied: '已处理',
        pending: '待处理',
        expired: '已过期',
        ignoreSuccess: '已忽略',
        ignoreFailed: '操作失败',
    },
    passCollapsed: '通过 ({count} 条)',
    expand: '展开',
    collapse: '收起',
    uncategorized: '未分类',
    noIssuesInSection: '该部分暂无问题',
    patent: {
        loading: '加载中...',
        loadError: '加载失败，请重试',
        noContent: '暂无内容',
        specification: '说明书',
        description: '发明内容',
    },
    field: {
        location: '位置',
        description: '问题描述',
        suggestion: '修改建议',
        oldContent: '原文',
        newContent: '修改后',
        source: '依据来源',
    },
    section: {
        abstract: '摘要',
        claims: '权利要求',
        title: '标题',
        specification: '说明书',
    },
    taskRunning: '当前有任务正在执行，请等待任务完成后再开始核稿',
    newReview: '新增核稿',
    selectDocument: '选择文档',
    noDocuments: '暂无文档',
    reviewPrompt: '使用核稿审查工具进行核稿',
    backToList: '返回列表',
    startReview: '开始核稿',
    words: '字',
    tab: {
        review: '核稿审查',
        rules: '规则管理',
    },
    customRules: {
        loadFailed: '加载规则失败，请重试',
        createSuccess: '规则创建成功',
        createFailed: '规则创建失败',
        updateSuccess: '规则更新成功',
        updateFailed: '规则更新失败',
        deleteSuccess: '规则删除成功',
        deleteFailed: '规则删除失败',
        create: '新建规则',
        searchPlaceholder: '搜索规则...',
        edit: '编辑',
        delete: '删除',
        deleteConfirm: '确认删除该规则？',
        confirmYes: '确认',
        confirmNo: '取消',
        empty: '暂无自定义规则',
        systemEmpty: '暂无系统规则',
        systemBadge: '系统',
        viewMy: '我的规则',
        viewSystem: '系统规则',
        col: {
            ruleId: '规则ID',
            patentOffice: '专利局',
            category: '分类',
            severity: '严重程度',
            description: '描述',
            message: '提示信息',
            status: '状态',
            createdAt: '创建时间',
            actions: '操作',
        },
        filter: {
            patentOffice: '专利局',
            category: '分类',
            status: '状态',
            enabled: '已启用',
            disabled: '已禁用',
        },
        category: {
            claims: '权利要求',
            abstract: '摘要',
            title: '标题',
            specification: '说明书',
            drawing_description: '附图说明',
            invention_content: '发明内容',
            field: '技术领域',
            punctuation: '标点符号',
            implementation: '具体实施方式',
            background: '背景技术',
            figures: '附图',
        },
        severity: {
            error: '错误',
            warning: '警告',
            info: '提示',
        },
        field: {
            patentOffice: '专利局',
            category: '分类',
            severity: '严重程度',
            description: '规则描述',
            descriptionPlaceholder: '例：背景技术应当客观描述相关现有技术',
            message: '提示信息',
            messagePlaceholder: '例：背景技术描述不符合要求',
            suggestion: '修改建议',
            suggestionPlaceholder: '例：客观描述相关现有技术，指出本发明要解决的技术问题',
            requirement: '规则要求',
            requirementPlaceholder: '例：\n写明对发明的理解、检索、审查有用的背景技术\n客观指出背景技术中存在的问题和缺点\n只指出本发明要解决的问题和缺点',
            requirementHint: '每行一条要求',
        },
        drawer: {
            titleCreate: '新建规则',
            titleEdit: '编辑规则',
            cancel: '取消',
            submit: '保存',
            submitting: '保存中...',
        },
        validation: {
            required: '此项为必填',
        },
    },
};
